export enum FAQGroupName {
    general = 'general',
    coverage = 'coverage',
    claim = 'claim',
    policy = 'policy'
}
